// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".general-section{border-radius:5%;border:2px solid #28a745;margin-bottom:5px}.general-nationality-flag{width:30px;height:30px}.player-name-section{margin-left:5px}.player-name{font-weight:bold}.skill-switcher-section{padding-top:20px}", ""]);
// Exports
module.exports = exports;
